import React from 'react'
import omit from 'lodash/omit'
import PropTypes from 'prop-types'
import RoundButton from 'components/Button/RoundButton'
import styled from 'styled-components'
import LanguageSwitcher from 'components/switches/LanguageSwitcher'
import Grid from 'components/grids/Grid'
import StoreForm from './StoreForm'
import StoreDetail from './StoreDetail'
import withStores from '../hocs/withStores'

const StoreListContainer = styled.div`
  padding-top: 10px;
  padding-bottom: 20px;
  padding-left: 5px;
  padding-right: 5px;
`

const StoreList = (props) => {
  const {
    stores = [],
    onChange,
    currentLang,
    isNew,
    isEditing,
    setIsNew,
    setIsEditing,
    editingStoreIndex,
    setEditingStoreIndex,
    createStoreLocation,
  } = props

  const handleOnSaveForm = (value) => {
    if (isEditing) {
      const newStores = [...stores]
      newStores[editingStoreIndex] = value
      onChange(newStores)
      setIsEditing(false)
      setEditingStoreIndex(undefined)
    } else if (isNew) {
      const newStores = stores.concat(value)
      onChange(newStores)
      setIsNew(false)
    }
  }
  const handleOnCancelForm = () => {
    if (isEditing) {
      setIsEditing(false)
      setEditingStoreIndex(undefined)
    } else if (isNew) {
      setIsNew(false)
    }
  }
  const creatingStore = createStoreLocation()
  const formStoresDetail = isNew ? creatingStore : stores[editingStoreIndex]
  return (
    <StoreListContainer>
      {/* LanguageSwitcher */}
      {
        (isEditing || isNew) ? (
          <StoreForm
            storeDetail={formStoresDetail}
            onSave={handleOnSaveForm}
            onCancel={handleOnCancelForm}
          />
        ) : (
          <div>
            <Grid>
              <Grid.Row style={{ paddingTop: 0 }} >
                <Grid.Column style={{ position: 'relative', height: 50 }}>
                  <LanguageSwitcher style={{ position: 'absolute', right: '1em' }} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {
              stores.map((store, index) => (
                <StoreDetail
                  key={store.id || index}
                  currentLang={currentLang}
                  setIsActive={
                    (value) => {
                      const newStores = [...stores]
                      newStores[index] = {
                        ...stores[index],
                        isActive: value,
                      }
                      onChange(newStores)
                    }
                  }
                  onEdit={() => {
                    setIsEditing(true)
                    setEditingStoreIndex(index)
                  }}
                  onDelete={() => {
                    const newStores = [...stores]
                    newStores.splice(index, 1)
                    onChange(newStores)
                  }}
                  // prevent redux getState error if pass store as props
                  // store will conflict with redux store
                  {...omit(store, 'store')}
                />
              ))
            }
            <RoundButton
              onClick={() => {
                // onChange(newStores)
                setIsNew(true)
              }}
            />
          </div>
        )
      }
    </StoreListContainer>
  )
}

StoreList.propTypes = {
  stores: PropTypes.array,
  onChange: PropTypes.func,
  currentLang: PropTypes.string,
  isNew: PropTypes.bool,
  isEditing: PropTypes.bool,
  setIsNew: PropTypes.func,
  setIsEditing: PropTypes.func,
  editingStoreIndex: PropTypes.number,
  setEditingStoreIndex: PropTypes.func,
  createStoreLocation: PropTypes.func,
}

StoreList.defaultProps = {
  stores: [],
  onChange: () => {},
  currentLang: undefined,
  isNew: false,
  isEditing: false,
  setIsNew: () => {},
  setIsEditing: () => {},
  editingStoreIndex: undefined,
  setEditingStoreIndex: () => {},
  createStoreLocation: () => {},
}

export default withStores()(StoreList)



// WEBPACK FOOTER //
// ./src/pages/StoreLocator/stores/StoreList.js